/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import { getEnergyUsedProductionByForm } from '../../../../../services/Elegibilidad/get'
import swal from 'sweetalert'
import { updateEnergyUsedProduction } from '../../../../../services/Elegibilidad/put'
import { insertEnergyUsedProduction } from '../../../../../services/Elegibilidad/create'
import { deleteEnergyUsedProduction } from '../../../../../services/Elegibilidad/delete'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'

const Table396 = ({ idElegibilityForm }) => {
  const [state, dispatch] = useEligibility()
  const [tableData, setTableData] = useState([])
  const [addOther, setAddOher] = useState(true)

  let DieselGasoline = null
  let Firewood = null
  let Gas = null
  let ElectricPower = null
  let RenewableEnergy = null

  const getDataTable = async () => {
    try {
      const response = await getEnergyUsedProductionByForm(idElegibilityForm)
      if (response.Success) {
        setTableData(response.Data)
        const result = response.Data.filter((obj) => obj.IdProcessType === 1)
        if (result.length === 0) setAddOher(true)
        else {
          setAddOher(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const handleActualizar = async (data) => {
    const body = {
      IdEnergyUsedProduction: data.IdEnergyUsedProduction,
      IdElegibilityAnswer: data.IdElegibilityAnswer,
      IdProcessType: data.IdProcessType,
      ProcessDetail: data.ProcessDetail,
      Diesel_Gasoline: DieselGasoline,
      Firewood: Firewood,
      Gas: Gas,
      ElectricPower: ElectricPower,
      RenewableEnergy: RenewableEnergy,
      IsDefault: data.IsDefault,
    }
    const response = await updateEnergyUsedProduction(body)
    if (response.Success) {
      getDataTable()
      DieselGasoline = null
      Firewood = null
      Gas = null
      ElectricPower = null
      RenewableEnergy = null
    }
  }

  const handleGuardar = async (data) => {
    const body = {
      IdEnergyUsedProduction: 0,
      IdElegibilityAnswer: idElegibilityForm,
      IdProcessType: 1,
      ProcessDetail: data.ProcessDetail,
      Diesel_Gasoline: DieselGasoline,
      Firewood: Firewood,
      Gas: Gas,
      ElectricPower: ElectricPower,
      RenewableEnergy: RenewableEnergy,
      IsDefault: false,
    }
    const response = await insertEnergyUsedProduction(body)
    if (response.Success) {
      swal({
        title: '¡Datos agregados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      DieselGasoline = null
      Firewood = null
      Gas = null
      ElectricPower = null
      RenewableEnergy = null
    }
  }

  const handleDelete = async (id) => {
    try {
      await deleteEnergyUsedProduction(id)
      getDataTable()
    } catch (error) {
      console.log(error)
    }
  }

  const alertValidationFields = () => {
    swal({
      title: 'Debe seleccionar un tipo de energía',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  const columns = [
    {
      title: 'Proceso o actividad productiva',
      field: 'ProcessDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
      validate: (rowData) =>
        rowData.ProcessDetail === '' ||
        rowData.ProcessDetail === null ||
        rowData.ProcessDetail === undefined ||
        rowData.ProcessDetail?.length > 100
          ? {
              isValid: false,
              helperText: 'Este campo es obligatorio (máximo 100 caracteres)',
            }
          : true,
    },
    {
      title: 'Diesel / Gasolina',
      field: 'Diesel_Gasoline',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (DieselGasoline === null) {
          DieselGasoline = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  DieselGasoline = true
                } else {
                  DieselGasoline = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Leña',
      field: 'Firewood',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (Firewood === null) {
          Firewood = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  Firewood = true
                } else {
                  Firewood = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Gas',
      field: 'Gas',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (Gas === null) {
          Gas = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  Gas = true
                } else {
                  Gas = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Energía eléctrica (servicio nacional o privado)',
      field: 'ElectricPower',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (ElectricPower === null) {
          ElectricPower = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  ElectricPower = true
                } else {
                  ElectricPower = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Energía limpias / Renovables',
      field: 'RenewableEnergy',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (RenewableEnergy === null) {
          RenewableEnergy = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  RenewableEnergy = true
                } else {
                  RenewableEnergy = false
                }
              }}
            />
          </Grid>
        )
      },
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            actions={[
              !addOther
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                        disabled
                      >
                        Agregar tipo de energía
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                  }
                : null,
            ]}
            editable={{
              isDeleteHidden: (rowData) => rowData.IdProcessType !== 1,

              onRowAdd: addOther
                ? (newRow) =>
                    new Promise((resolve, reject) => {
                      if (
                        DieselGasoline ||
                        Firewood ||
                        Gas ||
                        ElectricPower ||
                        RenewableEnergy
                      )
                        handleGuardar(newRow)
                      else {
                        alertValidationFields()
                      }
                      setTimeout(() => resolve(), 500)
                    })
                : null,
              onRowUpdate: (newData, oldData, rowData) =>
                new Promise((resolve, reject) => {
                  if (!oldData.IsDefault)
                    if (
                      DieselGasoline ||
                      Firewood ||
                      Gas ||
                      ElectricPower ||
                      RenewableEnergy
                    ) {
                      handleActualizar(newData)
                    } else {
                      alertValidationFields()
                    }
                  else {
                    handleActualizar(newData)
                  }
                  resolve()
                  setTimeout(() => {}, 1000)
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  handleDelete(oldData.IdEnergyUsedProduction)
                  setTimeout(() => resolve(), 500)
                }),
            }}
            // onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              addRowPosition: 'first',
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Add: () => (
                <Button
                  variant="contained"
                  color="success"
                  style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                  startIcon={<AddIcon style={{ color: 'white' }} />}
                >
                  Agregar tipo de energía
                </Button>
              ),
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table396)
